// Texty modalu „Přidáno do košíku" (cartModal.js). Doprava zdarma platí jen na
// výdejní místa (rozhodnutí 2026-08-21), proto texty nesou rozsah.
import { NBSP } from '../../modules/money.js';
import { plural } from '../plural.js';

export default {
  title: 'Přidáno do košíku',
  back: 'Zpět do obchodu',
  cart: 'Nákupní košík',
  upsellTitle: 'Ostatní zákazníci také nakoupili',
  freeShipScope: 'na výdejní místo',
  /** hlavička: „V košíku máte 2 položky za 1 298 Kč" */
  inCart: (count, price) => 'V košíku máte ' + count + ' ' + plural(count, ['položku', 'položky', 'položek']) + ' za ' + price,
  /** řádek dostupnosti za „Skladem (>5 ks) · "; `cutoff` = dnešní uzávěrka („14:30") */
  sendsToday: (cutoff) => 'odesíláme dnes při objednání do ' + cutoff,
  /** „Expedujeme zítra" (listingDispatch) → „odesíláme zítra" */
  sendsFrom: (label) => label.replace(/^Expedujeme/, 'odesíláme'),
  shipProgress: 'Postup k dopravě zdarma',
  /** vlaječky karty v upsellu (podle nativních tříd .flag-*) */
  flagNew: 'Novinka',
  flagTip: 'Tip',
  flagAction: 'Akce',
  /** nativní text dostupnosti karty v popupu Shoptetu (čte se, nekreslí) */
  inStockRe: /^skladem/i,
  inStock: 'Skladem',
  chooseVariant: 'Vybrat variantu',
  addToCart: 'Do košíku',
  added: 'Přidáno',
  close: 'Zavřít',
  prev: 'Předchozí produkty',
  next: 'Další produkty',
  save: (price) => 'Ušetříte ' + price,
  freeShipDone: (scope) => 'Dopravu ' + scope + ' máte zdarma!',
  // „Ještě <b>X Kč</b> a dopravu na výdejní místo máte <b>zdarma</b>" — flex řada,
  // mezery kolem tučných částí nese NBSP (holé by se mezi položkami sesypaly)
  leftPre: 'Ještě',
  leftMid: (scope) => 'a' + NBSP + 'dopravu ' + scope + ' máte',
  leftFree: 'zdarma',
  /** akce na dopravu pod progressem (#322): „Do té doby PPL na výdejní místo do 2 kg za 49 Kč, akce platí do 30. 11." */
  promoNote: (carrier, price, maxKg, until) =>
    'Do té doby ' + carrier + ' na výdejní místo do ' + maxKg + NBSP + 'kg za ' + price + ', akce platí do ' + until.replace(/\.$/, '') + '.',
};
